/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import React from 'react';
import classnames from 'classnames';
import Dialog from '@react/react-spectrum/Dialog';
import DialogManager from '../dialogManager';
import AppConfig from '../config';
import LoggerUtil from '../../utils/LoggerUtil';

export default class BaseDialog {
    show = (config = {}) => {
        if (this.key) {
            LoggerUtil.warn('Dialog already being shown, tried to show it again');
            return;
        }
        const { render, ...restProps } = this.dialogConfig;

        const onClose = () => {
            if (config.onClose) {
                config.onClose();
            }
            this.hide();
        };
        if (render) {
            this.key = DialogManager.show(
                <div className={AppConfig.cssWrapperClass}>
                    <Dialog className={classnames(config.className, restProps.className)}>
                        {render({ variant: config.variant })}
                    </Dialog>
                </div>,
                {
                    ...config,
                    onClose,
                    ...restProps,
                    wrapInDialog: false,
                    className: AppConfig.cssWrapperClass,
                }
            );
        }
    }

    hide = () => {
        if (this.key) {
            DialogManager.hide(this.key);
        }
        this.key = null;
    }
}
